﻿export function formatCurrency(amount, taxRate = 0, locale = null) {
    const parts = amount.split(' ');

    return formatNumber(parseNumber(parts[0], locale) / 100 * (100 + taxRate), {
        style: 'currency',
        currency: parts.length > 1 ? parts[1] : config.baseCurrency,
        currencyDisplay: 'narrowSymbol'
    }, locale);
}

export function formatDate(date, includeTime = false, longTime = false, locale = null) {
    const parts = new Intl.DateTimeFormat(locale ?? config.locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).formatToParts(date instanceof Date ? date : new Date(date)).reduce((a, p) => (a[p.type] = p.value, a), {});

    return `${parts.day}${getOrdinal(parts.day)} ${parts.month} ${parts.year}${(includeTime ? ` - ${parts.hour}:${parts.minute}${(longTime ? `:${parts.second}` : '')}` : '')}`;
}

export function formatDateTime(date, options = {}, locale = null) {
    return new Intl.DateTimeFormat(locale ?? config.locale, options).format(date instanceof Date ? date : new Date(date));
}

export function formatNumber(number, options = {}, locale = null) {
    return new Intl.NumberFormat(locale ?? config.locale, options).format(number);
}

export function getCurrencySymbol(currency, locale = null) {
    return formatNumber(0, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        currencyDisplay: 'narrowSymbol'
    }, locale).replace(/\d/g, '').trim();
}

export function getOrdinal(day) {
    if (day == 1 || day == 21 || day == 31)
        return 'st';
    else if (day == 2 || day == 22)
        return 'nd';
    else if (day == 3 || day == 23)
        return 'rd';
    else
        return 'th';
}

export function isNumber(string, locale = null) {
    return string != null && !isNaN(parseNumber(string, locale));
}

export function parseNumber(string, locale = null) {
    const thousandSeparator = Intl.NumberFormat(locale ?? config.locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale ?? config.locale).format(1.1).replace(/\p{Number}/gu, '');

    return parseFloat(string.replace(new RegExp('\\' + thousandSeparator, 'g'), '').replace(new RegExp('\\' + decimalSeparator), '.'));
}

export function round(number, digits = 0, locale = null) {
    return parseNumber(formatNumber(number, {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits
    }, locale), locale);
}

export function toMinorUnits(number) {
    return round(number * 100);
}